import { useEffect, useRef, useState } from 'react'

import { ClearSocketMessageHandler, ConnectWebSocketForScreen, DisconnectWebSocket, GetGenderMode, SetSocketMessageHandler } from './../../utilities/BL/Zones'

import { Questions } from './Sections/Questions'
import { Results } from './Sections/Results'
import { Wait } from './Sections/Wait'
import { Welcome } from './Sections/Welcome'
import { Colors } from './Sections/Colors'
import { Start } from './Sections/Start'
import { Thanks } from './Sections/Thanks'
import { Lottery } from './Sections/Lottery'
// import { GoalScreen } from './Sections/GoalScreen'
import { GoalScreenV2 } from './Sections/GoalScreenV2'
import { GoalScreenV2_Caminadora } from './Sections/GoalScreenV2_Caminadora'
import { Versus } from './Sections/Goal/Versus'
import Balloons from './Sections/Balloons'
import { Riddle } from './Sections/Riddle'
import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
import { FrontPage } from './Sections/QuizzWithImageAndOptions/FrontPage'
import { FrontPage as RiddleFrontPage } from './Sections/Riddle/FrontPage'
import { Rojito as RojitoBrandFrontPage } from './Sections/Balloons/FrontPages/Brands/Rojito'
import { Rojito as RojitoBrandBalloons } from './Sections/Balloons/Brands/RojitoDrinks'
import { Noisemeter } from './../Overlays/Noisemeter'
import { Noisemeter as FrontPageNoisemeter } from './../Overlays/Overlays/Noisemeter'
import { SelfieFan } from './Sections/SelfieFan'
import { QRSelfieFan } from './Sections/QRSelfieFan'
import { QRMessages } from './Sections/QRMessages'
import { SelfieFanIA } from './Sections/SelfieFanIA'
import { QRPluckingRooster } from './Sections/QRPluckingRooster'
import { RankingPluckingRooster } from './Sections/RankingPluckingRooster'
import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
import { LuchoFest } from './Sections/LuchoFest'
import { FrontPage as FrontPagePicnic } from './Sections/Picnic/FrontPagePicnic'
import { Picnic } from './Sections/Picnic'
import { FrontPageRunToGoal } from './Sections/Goal/FrontPageRunToGoal'
import { FrontPageRunToGoal as FrontPageRunToGoalDaikin } from './Sections/Goal/Brands/Daikin/FrontPageRunToGoal'
import { Tacos } from './Sections/Tacos'
import { FrontPageTacos } from './Sections/Tacos/FrontPageTacos'

import { SoupSimulator } from './Sections/Soup/Brands/SoupSimulator'
import { BriefcaseScreen } from './Sections/BriefcaseScreen'
import { FrontPageBriefcase } from './Sections/Briefcase/FrontPageBriefcase'

import { CatchTheBall } from './Sections/CatchTheBall'
import { SlotMachine } from './Sections/SlotMachine'

import { Voting } from './Sections/Voting'
import { FrontpageCaps } from './Sections/Caps/FrontpageCaps'
import { Caps } from './Sections/Caps'
import { Roulette } from './Sections/Roulette'


const Screen = () => {
    const [question, setQuestion] = useState(null)
    const [results, setResults] = useState(null)
    const [lottery, setLottery] = useState(null)
    const [connectionStatus, setConnectionStatus] = useState('idle')
    const [toastMessage, setToastMessage] = useState('')

    const [activeComponent, setActiveComponent] = useState(null)

    const [currentMatchId, setCurrentMatchId] = useState(null);
    const [phase, setPhase] = useState('idle');
    const [timing, setTiming] = useState({ startAt: null, endsAt: null });

    const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)

    const countdownTimerRef = useRef(null)
    const [balloonsUI, setBalloonsUI] = useState({
        uiStatus: 'Idle',
        countdownUntil: null
    })

    const [tacoMatchState, setTacoMatchState] = useState(null);
    const [catchMatchState, setCatchMatchState] = useState(null);
    const [capsMatchState, setCapsMatchState] = useState(null);
    const [slotPayload, setSlotPayload] = useState(null)
    const [roulettePayload, setRoulettePayload] = useState(null)
    
    const showToast = (msg) => {
        setToastMessage(msg)
        setTimeout(() => setToastMessage(''), 3000)
    }

    // // ENRUTADOR INTELIGENTE (Detecta si es V1 o V2)
    // const routeGoalByState = (state, matchData) => {
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         return (state === 'Running' || state === 'Finished') ? 5.2 : 5;
    //     }
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // // ENRUTADOR INTELIGENTE (Detecta si es V1 o V2)
    // const routeGoalByState = (state, matchData) => {
    //     // Verificamos si es V2
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         // Si está en espera, mostramos la Portada Animada (5.3)
    //         if (state === 'Waiting' || state === 'Idle') return 5.3;
    //         // Si está corriendo o finalizó, mostramos el juego y la animación de gol (5.2)
    //         return 5.2;
    //     }

    //     // Si no, es la V1 original (Se mantiene intacta)
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // // ENRUTADOR INTELIGENTE (A prueba de fallos)
    // const routeGoalByState = (state, matchData) => {
    //     // 1. Si el juego está en espera (recién entramos a la sección o reiniciamos),
    //     // SIEMPRE mostramos la Portada Animada Nueva, cortando de raíz cualquier error.
    //     if (state === 'Waiting' || state === 'Idle') {
    //         return 5.3;
    //     }

    //     // 2. Si el juego ya está corriendo o finalizó, verificamos si es V2
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         return 5.2; // Pantalla de Juego V2
    //     }

    //     // 3. Si no cumple lo anterior, nos vamos al juego V1 original
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // ENRUTADOR ESTRICTO V2 (Ignoramos la V1 para evitar interferencias)
    const routeGoalByState = (state) => {
        // Todo lo que sea espera o inicio, va a la Portada Animada (5.3)
        if (state === 'Waiting' || state === 'Idle') return 5.3;
        // Todo lo demás (Running, Finished) va al Juego V2 (5.2)
        return 5.2;
    }

    const SetGoalAndRoute = (updater) => {
        try {
            setGoal(prev => {
                const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
                setActiveComponent(routeGoalByState(next.state, next))
                return next
            })
        } catch (error) { }
    }

    const [goal, setGoal] = useState({
        matchId: null,
        state: 'Waiting',
        progressLucho: 0,
        progressTunita: 0,
        tapsParaGanar: 100,
        winner: null,
        elapsedMilliseconds: 0,
        zonesProgress: []
    })

    const [balloons, setBalloons] = useState({
        matchId: null,
        status: 'Waiting',
        startAt: null,
        endsAt: null,
        target: 0,
        zones: [],
        winners: null
    })

    // ==========================================
    // ESTADO NUEVO: VAS O NO VAS (MALETINES)
    // ==========================================
    const [briefcaseState, setBriefcaseState] = useState({
        phase: 'WAITING',
        briefcases: [], // El backend nos mandará el arreglo de maletines
        suspenseBriefcaseId: null,
        revealData: null
    })

    const RouteBalloonsByStatus = (s, next) => {
        const hasCountdown = next?.startAt && new Date(next.startAt).getTime() > Date.now()
        if (s === 'Running' || s === 'Finished' || hasCountdown) return 10.1
        return 10
    }

    const SetBalloonsAndRoute = (updater) => {
        setBalloons(prev => {
            const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
            setActiveComponent(RouteBalloonsByStatus(next.status, next))
            return next
        })
    }

    const forceUIStatus = (status) => {
        setBalloonsUI(prev => {
            const order = { Idle: 0, Countdown: 1, Running: 2, Finished: 3 };
            return order[status] >= order[prev.uiStatus]
                ? { ...prev, uiStatus: status }
                : prev;
        });
    };

    useEffect(() => {
        const connect = async () => {
            await ConnectWebSocketForScreen(setConnectionStatus, showToast)
            SetSocketMessageHandler(handleIncomingMessage)
        }

        const handleIncomingMessage = async (message) => {
            if (!message || !message.type) return

            const response = await GetGenderMode()
            if (response.success) {
                setIsActiveWomensMode(response.data.isWomensModeActive)
            } else {
                setIsActiveWomensMode(false)
            }

            switch (message.type.toLowerCase()) {
                case 'welcome':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(9)
                    break

                case 'wait':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(1)
                    break

                case 'newinstruction':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(2)
                    break

                case 'trivia':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(3)
                    break

                case 'finalresults':
                    setLottery(null); setQuestion(null); setResults(message);
                    setActiveComponent(3.1)
                    break

                case 'loteria':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(4)
                    break

                case 'lotterycard':
                    setLottery(message); setQuestion(null); setResults(null);
                    setActiveComponent(4.1)
                    break

                case 'colores':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(6)
                    break

                case 'setzonecolor':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(6.1)
                    break

                case 'start':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(7)
                    break

                case 'thanks':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(8)
                    break

                // ───────────── RunToGoal (V1 y V2) ─────────────
                // // 1. AGRUPAMOS LOS 3 EVENTOS DE LIMPIEZA AQUÍ:
                // case 'goal':
                // case 'goal.layout':
                // case 'goal.prepare':
                // case 'goal.reset':
                //     SetGoalAndRoute(g => ({
                //         ...g,
                //         state: 'Waiting',
                //         phase: 'Waiting',
                //         elapsedMilliseconds: 0, // CRÍTICO PARA LANZAR LA PORTADA (5.3)
                //         progressLucho: 0,
                //         progressTunita: 0,
                //         winner: null,
                //         zonesProgress: []
                //     }))
                //     break

                // case 'goal.created': {
                //     const cfg = message.payload?.cfg || {}
                //     SetGoalAndRoute({
                //         matchId: message.payload?.matchId ?? null,
                //         state: 'Waiting',
                //         phase: 'Waiting',
                //         elapsedMilliseconds: 0, // CRÍTICO PARA EL RESET V2
                //         totalDurationMilliseconds: (cfg.durationSeconds || 15) * 1000,
                //         progressLucho: 0,
                //         progressTunita: 0,
                //         tapsParaGanar: cfg.tapsParaGanar ?? 100,
                //         winner: null,
                //         zonesProgress: []
                //     })
                //     break
                // }

                // Estos 4 eventos ahora hacen exactamente lo mismo: Limpiar la memoria y mostrar la portada (5.3)
                case 'goal.frontpage':
                case 'goal.layout':
                case 'goal.prepare':
                case 'goal.reset':
                    SetGoalAndRoute(g => ({
                        ...g,
                        matchId: message.payload?.matchId ?? null,
                        state: 'Waiting',
                        phase: 'Waiting',
                        elapsedMilliseconds: 0,
                        progressLucho: 0,
                        progressTunita: 0,
                        tapsParaGanar: 100,
                        winner: null,
                        zonesProgress: []
                    }))
                    break

                case 'goal.created': {
                    const cfg = message.payload?.cfg || {}
                    SetGoalAndRoute({
                        matchId: message.payload?.matchId ?? null,
                        state: 'Waiting',
                        phase: 'Waiting',
                        elapsedMilliseconds: 0,
                        totalDurationMilliseconds: (cfg.durationSeconds || 15) * 1000,
                        progressLucho: 0,
                        progressTunita: 0,
                        tapsParaGanar: cfg.tapsParaGanar ?? 100,
                        winner: null,
                        zonesProgress: []
                    })
                    break
                }

                case 'goal.snapshot': {
                    // const p = message.payload || {}
                    // SetGoalAndRoute({
                    //     ...p,
                    //     matchId: p.matchId ?? null,
                    //     state: p.state ?? 'Waiting',
                    //     phase: p.state ?? 'Waiting',
                    //     progressLucho: p.progressLucho ?? 0,
                    //     progressTunita: p.progressTunita ?? 0,
                    //     tapsParaGanar: p.tapsParaGanar ?? 100,
                    //     winner: p.winner ?? null
                    // })

                    const p = message.payload || {}
                    // Modificamos esto para que use el estado previo (g) y NO borre el elapsedMilliseconds=0
                    SetGoalAndRoute(g => ({
                        ...g,
                        ...p,
                        matchId: p.matchId ?? g.matchId ?? null,
                        state: p.state ?? 'Waiting',
                        phase: p.state ?? 'Waiting',
                        elapsedMilliseconds: p.elapsedMilliseconds !== undefined ? p.elapsedMilliseconds : g.elapsedMilliseconds, // Respeta el 0
                        progressLucho: p.progressLucho ?? g.progressLucho ?? 0,
                        progressTunita: p.progressTunita ?? g.progressTunita ?? 0,
                        tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar ?? 100,
                        winner: p.winner ?? g.winner ?? null
                    }))
                    break
                }

                case 'goal.started':
                    SetGoalAndRoute(g => ({
                        ...g,
                        state: 'Running',
                        phase: 'Running',
                        winner: null,
                        progressLucho: 0,
                        progressTunita: 0
                    }))
                    break

                case 'goal.progress': {
                    const p = message.payload || {}
                    if (p.elapsedMilliseconds !== undefined) {
                        // V2
                        SetGoalAndRoute(g => ({ ...g, ...p, state: 'Running', phase: 'Running' }))
                    } else {
                        // V1
                        SetGoalAndRoute(g => ({
                            ...g,
                            state: 'Running',
                            phase: 'Running',
                            progressLucho: p.progressLucho ?? g.progressLucho,
                            progressTunita: p.progressTunita ?? g.progressTunita,
                            tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar
                        }))
                    }
                    break
                }

                case 'goal.finished': {
                    const p = message.payload || {}
                    if (p.finalZonesProgress !== undefined) {
                        // V2
                        SetGoalAndRoute(g => ({ ...g, ...p, state: 'Finished', phase: 'Finished', winner: p.winner ?? null }))
                    } else {
                        // V1
                        SetGoalAndRoute(g => ({
                            ...g,
                            state: 'Finished',
                            phase: 'Finished',
                            winner: p.winner ?? null,
                            progressLucho: p.progressLucho ?? g.progressLucho,
                            progressTunita: p.progressTunita ?? g.progressTunita
                        }))
                    }
                    break
                }

                // ───────────── Globos (pantalla) ─────────────
                case 'ballons': {
                    SetBalloonsAndRoute({
                        matchId: null, status: 'Waiting', startAt: null, endsAt: null,
                        target: 0, zones: [], winners: null
                    });
                    break;
                }

                case 'ballonsgame': {
                    SetBalloonsAndRoute(b => ({ ...b, status: 'Waiting' }));
                    break;
                }

                case 'balloon.prepare': {
                    const d = message.data || {}
                    const durationSec = (typeof d.matchDurationSec === 'number' && d.matchDurationSec > 0)
                        ? d.matchDurationSec
                        : ((d.endsAt && d.startAt) ? Math.max(0, Math.floor((Date.parse(d.endsAt) - Date.parse(d.startAt)) / 1000)) : 0)

                    const localCountdownMs = 3000
                    const localStartAt = Date.now() + localCountdownMs
                    const localEndsAt = localStartAt + (durationSec * 1000)

                    SetBalloonsAndRoute(b => ({
                        ...b,
                        matchId: d.matchId ?? d.MatchId ?? b.matchId,
                        status: 'Waiting',
                        startAt: new Date(localStartAt).toISOString(),
                        endsAt: new Date(localEndsAt).toISOString(),
                        target: d.targetTapsPerBalloon ?? d.TargetTapsPerBalloon ?? b.target,
                        winners: null
                    }))
                    break
                }

                case 'balloon.state': {
                    const st = message.data || {}
                    const rawStatus = st.status ?? st.Status
                    const statusNorm = rawStatus === 0 || rawStatus === 'Waiting' ? 'Waiting' :
                        rawStatus === 1 || rawStatus === 'Running' ? 'Running' :
                            rawStatus === 2 || rawStatus === 'Finished' ? 'Finished' : 'Waiting';

                    const matchId = st.matchId ?? st.MatchId ?? null
                    const target = st.targetTapsPerBalloon ?? st.TargetTapsPerBalloon ?? null

                    const zonesIn = st.zones ?? st.Zones;
                    const zonesNorm = Array.isArray(zonesIn)
                        ? zonesIn.map(z => ({
                            zone: (z.zone ?? z.Zone ?? '').toString(),
                            currentBalloonTaps: z.currentBalloonTaps ?? z.CurrentBalloonTaps ?? 0,
                            completedBalloons: z.completedBalloons ?? z.CompletedBalloons ?? 0,
                            totalTaps: z.totalTaps ?? z.TotalTaps ?? 0
                        }))
                        : null

                    SetBalloonsAndRoute(b => ({
                        ...b, matchId: matchId ?? b.matchId, status: statusNorm,
                        startAt: null, endsAt: null, target: target ?? b.target, zones: zonesNorm ?? b.zones
                    }))

                    if (statusNorm === 'Running') forceUIStatus('Running')
                    if (statusNorm === 'Finished') forceUIStatus('Finished')
                    break
                }

                case 'balloon.show-winners': {
                    const d = message.data || {}
                    SetBalloonsAndRoute(b => ({
                        ...b,
                        matchId: d.matchId ?? b.matchId,
                        status: 'Finished',
                        winners: { winnerType: d.winnerType || 'none', winners: d.winners || [], results: d.results || [] }
                    }))
                    forceUIStatus('Finished')
                    break
                }

                case 'balloon.reset': {
                    if (countdownTimerRef.current) { clearTimeout(countdownTimerRef.current); countdownTimerRef.current = null; }
                    SetBalloonsAndRoute({ matchId: null, status: 'Waiting', startAt: null, endsAt: null, target: 0, zones: [], winners: null });
                    setBalloonsUI({ uiStatus: 'Idle', countdownUntil: null });
                    break;
                }

                case 'riddle':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(11)
                    break

                case 'newquestionriddler':
                case 'resumequestionriddler':
                case 'riddledisplayitem':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(11.1)
                    break

                case 'deselectedselfiefan':
                case 'resetselfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12)
                    break

                case 'displayselfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12.1)
                    break

                case 'selfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(13)
                    break

                case 'displayselfiefania':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(14)
                    break

                case 'deselectedselfiefania':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12)
                    break

                case 'quizzwithimageandoptions':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(15)
                    break

                case 'newquestionquizzwithimageandoptions':
                case 'resumequestionquizzwithimageandoptions':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(15.1)
                    break

                case 'frontpagenoisemeter':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(16)
                    break

                case 'noisemeter.prepare':
                case 'noisemeter.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(16.1)
                    break

                case 'qrmessages':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(17)
                    break

                case 'qrpluckingrooster':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(18)
                    break

                case 'rankingpluckingrooster':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(19)
                    break

                case 'frontpageluchofest':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(20)
                    break

                case "luchofest.game_running":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'playing' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.show_winner":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'winner' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.show_practice_finished":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'practice' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.stop":
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(20)
                    break

                case 'picnic.layout':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(21)
                    break

                case 'picnic.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(21.1)
                    break

                // ==========================================
                // DINÁMICA: VAS O NO VAS (MALETINES)
                // ==========================================
                case 'briefcase.layout':
                    // Limpiamos basura de otros juegos
                    setLottery(null); setQuestion(null); setResults(null);
                    // Seteamos una vista previa por defecto (9 maletines cerrados) en lo que arranca
                    setBriefcaseState({
                        phase: 'WAITING',
                        briefcases: Array.from({ length: 9 }, (_, i) => ({ id: i + 1, state: 'closed', prizeTheme: 'none' })),
                        suspenseBriefcaseId: null,
                        revealData: null
                    });
                    setActiveComponent(22);
                    break;

                case 'briefcase.update':
                    // El backend nos mandará el estado completo del juego cada que el Admin abra un maletín
                    if (message.payload) {
                        setBriefcaseState(message.payload);
                        setActiveComponent(22.1);
                    }
                    break;

                // ==========================================
                // DINÁMICA: Velocidad taquera
                // ==========================================
                case 'taco.layout':
                case 'taco.reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTacoMatchState(null); // Limpiamos para volver a la configuración base
                    setActiveComponent(23.1); 
                    break;

                case 'taco.progress':
                case 'taco.finished':
                    if (message.payload) {
                        setTacoMatchState(message.payload);
                        setActiveComponent(23.1);
                    }
                    break;

                case 'taco.frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTacoMatchState(null);
                    setActiveComponent(23); 
                    break;

                case 'catchtheball':
                    setCatchMatchState(message.data); // data trae action y payload
                    setActiveComponent(24); // Usamos el ID 24 para esta dinámica
                    break;

                // ───────────── Tragamonedas ─────────────
                case 'slotmachine.enter':
                case 'slotmachine.prepare':
                case 'slotmachine.spin':
                case 'slotmachine.toggleqr':
                case 'slotmachine.togglethanks':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    
                    // Guardamos el mensaje completo para pasárselo a la máquina
                    setSlotPayload(message);
                    
                    // Aseguramos que el componente 25 esté en pantalla
                    setActiveComponent(25);
                    break;

                case 'voting.start':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(26); // Usaremos el 30 para la votación en pantalla
                    break;
                case 'voting.results':
                    setLottery(null); setQuestion(null); setResults(message.data);
                    setActiveComponent(26.1); 
                    break;

                // ==========================================
                // DINÁMICA: GORRAS / BOLITA (CAPS)
                // ==========================================
                case 'caps.layout':
                    setLottery(null); setQuestion(null); setResults(null);
                    setCapsMatchState(null);
                    setActiveComponent(27); // Mostramos Portada
                    break;

                case 'caps.progress':
                case 'caps.reset':
                    if (message.payload) {
                        setCapsMatchState(message.payload);
                    } else {
                        setCapsMatchState(null);
                    }
                    setActiveComponent(27.1); // Mostramos Juego
                    break;

                // ───────────── Ruleta ─────────────
                case 'roulette.prepare':
                case 'roulette.spin':
                case 'roulette.toggleqr':
                case 'roulette.togglethanks':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    
                    // Guardamos el mensaje completo para la ruleta
                    setRoulettePayload(message);
                    
                    // Aseguramos que el componente 28 esté en pantalla
                    setActiveComponent(28);
                    break;

                default:
                    console.log('Unknown:', message.type)
                    break
            }
        }

        connect()
        document.body.classList.add('customBg')

        return () => {
            ClearSocketMessageHandler()
            DisconnectWebSocket()
            if (countdownTimerRef.current) clearTimeout(countdownTimerRef.current);
        }
    }, [])

    return (
        <>
            {activeComponent === 1 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 2 && (<Questions question={question} />)}
            {activeComponent === 3 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 3.1 && (<Results payload={results} />)}
            {activeComponent === 4 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 4.1 && (<Lottery payload={lottery} />)}
            {/* {activeComponent === 5 && (<Versus isActiveWomensMode={isActiveWomensMode} />)} */}
            {/* {activeComponent === 5.1 && (<GoalScreen state={goal} />)} */}
            {activeComponent === 5.2 && (<GoalScreenV2 currentMatchState={goal} />)}
            {activeComponent === 5.3 && (<FrontPageRunToGoal isActiveWomensMode={isActiveWomensMode} />)}
            {/* {activeComponent === 5.3 && (<FrontPageRunToGoalDaikin />)} */}
            {/* {activeComponent === 5.3 && (<FrontPageRunToGoal />)} Para La Moderna */}
            {/* {activeComponent === 5.2 && (<GoalScreenV2_Caminadora currentMatchState={goal} />)} */}
            {activeComponent === 6 && (<Colors />)}
            {activeComponent === 6.1 && (<Colors />)}
            {activeComponent === 7 && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 8 && (<Thanks isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 9 && (<Welcome isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 10 && (<RojitoBrandFrontPage isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 10.1 && (<RojitoBrandBalloons state={balloons} ui={balloonsUI} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 11 && (<RiddleFrontPage isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 11.1 && (<Riddle riddle={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 12 && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 12.1 && (<SelfieFan selfieFan={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 13 && (<QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 14 && (<SelfieFanIA selfieFan={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 15 && (<FrontPage data={question} />)}
            {activeComponent === 15.1 && (<QuizzWithImageAndOptions quizz={question} />)}
            {activeComponent === 16 && (<FrontPageNoisemeter isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 16.1 && (<Noisemeter data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 17 && (<QRMessages data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 18 && (<QRPluckingRooster data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 19 && (<RankingPluckingRooster data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 20 && (<FrontPageLuchoFest isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 20.1 && (<LuchoFest question={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 21 && (<FrontPagePicnic isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 21.1 && (<Picnic matchResults={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 22 && (<FrontPageBriefcase />)}
            {activeComponent === 22.1 && (<BriefcaseScreen currentGameState={briefcaseState} />)}
            {activeComponent === 23 && (<FrontPageTacos />)}
            {activeComponent === 23.1 && (<Tacos currentGameState={tacoMatchState} />)}
            {activeComponent === 24 && (<CatchTheBall incomingData={catchMatchState} />)}
            {activeComponent === 25 && ( <SlotMachine screenId={1} isStandalone={false} payload={slotPayload} /> )}
            {activeComponent === 26 && (<Voting payload={question} results={null} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 26.1 && (<Voting payload={null} results={results} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 26.1 && (<Voting payload={null} results={results} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 27 && (<FrontpageCaps isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 27.1 && (<Caps currentGameState={capsMatchState} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 28 && (<Roulette screenId={1} isStandalone={false} payload={roulettePayload} />)}
            {!activeComponent && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            
            {toastMessage && (
                <div className="toast-container position-fixed bottom-0 start-50 translate-middle-x mb-3">
                    <div className="toast show bg-success text-white px-3 py-2 shadow rounded">
                        {toastMessage}
                    </div>
                </div>
            )}
        </>
    )
}

export { Screen };









// import { useEffect, useRef, useState } from 'react'

// import { ClearSocketMessageHandler, ConnectWebSocketForScreen, DisconnectWebSocket, GetGenderMode, SetSocketMessageHandler } from './../../utilities/BL/Zones'

// import { Questions } from './Sections/Questions'
// import { Results } from './Sections/Results'
// import { Wait } from './Sections/Wait'
// import { Welcome } from './Sections/Welcome'
// import { Colors } from './Sections/Colors'
// import { Start } from './Sections/Start'
// import { Thanks } from './Sections/Thanks'
// import { Lottery } from './Sections/Lottery'
// import { GoalScreen } from './Sections/GoalScreen'
// import { GoalScreenV2 } from './Sections/GoalScreenV2'
// import { GoalScreenV2_Caminadora } from './Sections/GoalScreenV2_Caminadora'
// import { Versus } from './Sections/Goal/Versus'
// import Balloons from './Sections/Balloons'
// import { Riddle } from './Sections/Riddle'
// import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
// import { FrontPage } from './Sections/QuizzWithImageAndOptions/FrontPage'
// import { FrontPage as RiddleFrontPage } from './Sections/Riddle/FrontPage'
// import { Rojito as RojitoBrandFrontPage } from './Sections/Balloons/FrontPages/Brands/Rojito'
// import { Rojito as RojitoBrandBalloons } from './Sections/Balloons/Brands/RojitoDrinks'
// // import { Karaoke } from './Sections/Karaoke'
// import { Noisemeter } from './../Overlays/Noisemeter'
// import { Noisemeter as FrontPageNoisemeter } from './../Overlays/Overlays/Noisemeter'
// import { SelfieFan } from './Sections/SelfieFan'
// import { QRSelfieFan } from './Sections/QRSelfieFan'
// import { QRMessages } from './Sections/QRMessages'
// import { SelfieFanIA } from './Sections/SelfieFanIA'
// import { QRPluckingRooster } from './Sections/QRPluckingRooster'
// import { RankingPluckingRooster } from './Sections/RankingPluckingRooster'
// import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
// import { LuchoFest } from './Sections/LuchoFest'
// import { FrontPage as FrontPagePicnic } from './Sections/Picnic/FrontPagePicnic'
// import { Picnic } from './Sections/Picnic'
// import { FrontPageRunToGoal } from './Sections/Goal/FrontPageRunToGoal'
// import { FrontPageRunToGoal as FrontPageRunToGoalDaikin } from './Sections/Goal/Brands/Daikin/FrontPageRunToGoal'
// import { Tacos } from './Sections/Tacos'
// import { FrontPageTacos } from './Sections/Tacos/FrontPageTacos'

// import { SoupSimulator } from './Sections/Soup/Brands/SoupSimulator'
// import { BriefcaseScreen } from './Sections/BriefcaseScreen'
// import { FrontPageBriefcase } from './Sections/Briefcase/FrontPageBriefcase'

// import { CatchTheBall } from './Sections/CatchTheBall'
// import { SlotMachine } from './Sections/SlotMachine'

// import { Voting } from './Sections/Voting'

// // import { ZoneList } from './Sections/components/ZoneList'

// // import { pickColor } from './Sections/components/Color'
// // import BalloonsScreen from './Sections/BalloonsScreen'


// const Screen = () => {
//     const [question, setQuestion] = useState(null)
//     const [results, setResults] = useState(null)
//     const [lottery, setLottery] = useState(null)
//     const [connectionStatus, setConnectionStatus] = useState('idle') // idle, connecting, connected, reconnecting, error
//     const [toastMessage, setToastMessage] = useState('')
    
//     const [activeComponent,setActiveComponent] = useState(null)

//     const [currentMatchId, setCurrentMatchId] = useState(null);
//     const [phase, setPhase] = useState('idle'); // 'idle' | 'waiting' | 'countdown' | 'running' | 'ended'
//     const [timing, setTiming] = useState({ startAt: null, endsAt: null });

//     const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)

//     const clampPhase = (nextPhase) => {
//         const order = { idle: 0, waiting: 1, countdown: 2, running: 3, ended: 4 }
//         setPhase((prev) => (order[nextPhase] > order[prev] ? nextPhase : prev))
//     }

//     // --- UI local para globos (no dependemos del reloj)
//     const countdownTimerRef = useRef(null)   // id del setTimeout
//     const [balloonsUI, setBalloonsUI] = useState({
//         uiStatus: 'Idle',          // Idle | Countdown | Running | Finished
//         countdownUntil: null       // timestamp (ms) para mostrar 3..2..1
//     })

//     const [slotPayload, setSlotPayload] = useState(null)


//     const showToast = (msg) => {
//         setToastMessage(msg)
//         setTimeout(() => setToastMessage(''), 3000)
//     }

//     const routeGoalByState = (state) =>
//         (state === 'Running' || state === 'Finished') ? 5.1 : 5

//     // setter centralizado: actualiza 'goal' y el componente activo coherentemente
//     const SetGoalAndRoute = (updater) => {
//         try {
//             setGoal(prev => {
//                 const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
//                 setActiveComponent(routeGoalByState(next.state))
//                 return next
//             })
//         } catch (error) {
            
//         }
//     }

//     // estado de RunToGoal
//     const [goal,setGoal] = useState({
//         matchId: null,
//         state: 'Waiting',            // Waiting | Running | Finished
//         progressLucho: 0,
//         progressTunita: 0,
//         tapsParaGanar: 100,
//         winner: null
//     })

//     // estado de Balloons (pantalla grande)
//     const [balloons, setBalloons] = useState({
//         matchId: null,
//         status: 'Waiting',      // Waiting | Running | Finished
//         startAt: null,
//         endsAt: null,
//         target: 0,              // targetTapsPerBalloon
//         zones: [],              // [{ zone, currentBalloonTaps, completedBalloons, totalTaps }]
//         winners: null           // { winnerType, winners:[], results:[] } o null
//     })

//     // const RouteBalloonsByStatus = (s) =>
//     //     (s === 'Running' || s === 'Finished') ? 10.1 : 10

//     // const SetBalloonsAndRoute = (updater) => {
//     //     setBalloons(prev => {
//     //         const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
//     //         setActiveComponent(RouteBalloonsByStatus(next.status))
//     //         return next
//     //     });
//     // };

//     // OJO: si hay startAt futuro (countdown), muestra 10.1 (juego) aunque status sea Waiting
//     const RouteBalloonsByStatus = (s, next) => {
//         const hasCountdown = next?.startAt && new Date(next.startAt).getTime() > Date.now()
//         if (s === 'Running' || s === 'Finished' || hasCountdown) return 10.1
//         return 10
//     }

//     const SetBalloonsAndRoute = (updater) => {
//         setBalloons(prev => {
//             const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
//             setActiveComponent(RouteBalloonsByStatus(next.status, next))
//             return next
//         })
//     }

//     const startLocalCountdown = (matchId) => {
//         // limpia un countdown anterior
//         if (countdownTimerRef.current) {
//             clearTimeout(countdownTimerRef.current);
//             countdownTimerRef.current = null;
//         }

//         const until = Date.now() + 3000; // 3 segundos

//         // pinta estado local "Countdown"
//         setBalloonsUI({ uiStatus: 'Countdown', countdownUntil: until });

//         // programa el salto automático a "Running" (solo si sigue la misma partida)
//         countdownTimerRef.current = setTimeout(() => {
//             setBalloonsUI(prev => {
//             // si otro flujo ya marcó Finished, respétalo
//             if (prev.uiStatus === 'Finished') return prev;
//                 return { uiStatus: 'Running', countdownUntil: null };
//             });
//         }, 3000);
//         };

//         const forceUIStatus = (status) => {
//         // utilitario para no retroceder de Running->Waiting
//         setBalloonsUI(prev => {
//             const order = { Idle: 0, Countdown: 1, Running: 2, Finished: 3 };
//             return order[status] >= order[prev.uiStatus]
//             ? { ...prev, uiStatus: status }
//             : prev;
//         });
//     };

//     useEffect(() => {
//         const connect = async () => {
//             await ConnectWebSocketForScreen(setConnectionStatus, showToast)
//             SetSocketMessageHandler(handleIncomingMessage)
//         }

//         const handleIncomingMessage = async (message) => {
//             if (!message || !message.type) return

//             // // Log de todo lo que llega a la PANTALLA
//             // //console.log("[SCREEN WS]", message.type, message.data || message.payload || message)


//             // const t = message.type?.toLowerCase?.() || ''
            
//             // const isBalloonsActive =
//             //     Boolean(balloons?.matchId) &&
//             //     (balloons?.status === 'Waiting' || balloons?.status === 'Running')

//             // const blockWhileBalloons = new Set([
//             //     'welcome','wait','start','thanks',
//             //     'trivia','finalresults','loteria','setzonecolor'
//             // ])

//             // if (isBalloonsActive && blockWhileBalloons.has(t)) {
//             //     // Ignora estos eventos para no cambiar de vista en mitad del juego
//             //     return
//             // }


//             // Obtener el género o modo actual
//             const response = await GetGenderMode()

//             if (response.success) {
//                 setIsActiveWomensMode(response.data.isWomensModeActive)
//             } else {
//                 setIsActiveWomensMode(false)
//             }

            
//             switch (message.type.toLowerCase()) {
//                 case 'welcome':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(9)
//                     break

//                 case 'wait':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(1)
//                     break
 
//                 case 'newinstruction':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(2)
//                     break

//                 case 'trivia':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(3)
//                     break

//                 case 'finalresults':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(message)
//                     //setColor(null)
//                     setActiveComponent(3.1)
//                     break

//                 case 'loteria':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(4)
//                     break

//                 case 'lotterycard':
                    
//                     setLottery(message)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(4.1)
//                     break

//                 case 'colores':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(6)
//                     break

//                 case 'setzonecolor':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(message.data)
//                     //setColor(null)
//                     setActiveComponent(6.1)
//                     break

//                 case 'start': //Antes recommendations
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(7)
//                     break

//                 case 'thanks':
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(8)
//                     break

//                 // ───────────── RunToGoal ─────────────
//                 case 'goal.layout':
//                     SetGoalAndRoute(g => ({ ...g, state: g.state || 'Waiting' }))
//                     break

//                 case 'goal.created':
//                     const cfg = message.payload?.cfg || {}

//                     SetGoalAndRoute({
//                         matchId: message.payload?.matchId ?? null,
//                         state: 'Waiting',
//                         progressLucho: 0,
//                         progressTunita: 0,
//                         tapsParaGanar: cfg.tapsParaGanar ?? 100,
//                         winner: null
//                     })
//                     break

//                 case 'goal.prepare':
//                     SetGoalAndRoute(g => ({
//                         ...g,
//                         state: 'Waiting',
//                         progressLucho: 0,
//                         progressTunita: 0,
//                         winner: null
//                     }))
//                     break

//                 case 'goal.snapshot': {
//                     const p = message.payload || {}
//                     SetGoalAndRoute({
//                         matchId: p.matchId ?? null,
//                         state: p.state ?? 'Waiting',
//                         progressLucho: p.progressLucho ?? 0,
//                         progressTunita: p.progressTunita ?? 0,
//                         tapsParaGanar: p.tapsParaGanar ?? 100,
//                         winner: p.winner ?? null
//                     })
//                     break
//                 }

//                 case 'goal.started':
//                     SetGoalAndRoute(g => ({ ...g, state: 'Running', winner: null, progressLucho: 0, progressTunita: 0 }))
//                     break

//                 case 'goal.progress': {
//                     const p = message.payload || {}
//                     SetGoalAndRoute(g => ({
//                         ...g,
//                         state: 'Running',
//                         progressLucho: p.progressLucho ?? g.progressLucho,
//                         progressTunita: p.progressTunita ?? g.progressTunita,
//                         tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar
//                     }))
//                     break
//                 }

//                 case 'goal.finished': {
//                     const p = message.payload || {}
//                     SetGoalAndRoute(g => ({
//                         ...g,
//                         state: 'Finished',
//                         winner: p.winner ?? null,
//                         progressLucho: p.progressLucho ?? g.progressLucho,
//                         progressTunita: p.progressTunita ?? g.progressTunita
//                     }))
//                     break
//                 }

//                 // ───────────── Globos (pantalla) ─────────────
//                 case 'ballons': {
//                     // Layout de espera (no hay partida aún)
//                     SetBalloonsAndRoute({
//                         matchId: null,
//                         status: 'Waiting',
//                         startAt: null,
//                         endsAt: null,
//                         target: 0,
//                         zones: [],
//                         winners: null
//                     });
//                     break;
//                 }

//                 case 'ballonsgame': { // toLowerCase() => minúsculas
//                     // Vista de juego (UI), aún sin tiempos; el prepare/state llegará después
//                     SetBalloonsAndRoute(b => ({
//                         ...b,
//                         status: 'Waiting'
//                     }));
//                     break;
//                 }

//                 case 'balloon.prepare': {
//                     const d = message.data || {}

//                     const durationSec =
//                         (typeof d.matchDurationSec === 'number' && d.matchDurationSec > 0)
//                             ? d.matchDurationSec
//                             : ((d.endsAt && d.startAt)
//                                 ? Math.max(0, Math.floor((Date.parse(d.endsAt) - Date.parse(d.startAt)) / 1000))
//                                 : 0)

//                     // 3-2-1 local de pantalla (si quieres mantenerlo fijo en 3s)
//                     const localCountdownMs = 3000
//                     const localStartAt = Date.now() + localCountdownMs
//                     const localEndsAt  = localStartAt + (durationSec * 1000)

//                     // Soporta PascalCase y camelCase
//                     SetBalloonsAndRoute(b => ({
//                         ...b,
//                         matchId: d.matchId ?? d.MatchId ?? b.matchId,
//                         status: 'Waiting',              // arranca en Waiting durante 3-2-1
//                         startAt: new Date(localStartAt).toISOString(),
//                         endsAt: new Date(localEndsAt).toISOString(),
//                         target: d.targetTapsPerBalloon ?? d.TargetTapsPerBalloon ?? b.target,
//                         winners: null
//                     }))
//                     break
//                 }

//                 case 'balloon.state': {
//                     const st = message.data || {}

//                     const rawStatus = st.status ?? st.Status

//                     const statusNorm =
//                         rawStatus === 0 || rawStatus === 'Waiting' ? 'Waiting' :
//                         rawStatus === 1 || rawStatus === 'Running' ? 'Running' :
//                         rawStatus === 2 || rawStatus === 'Finished' ? 'Finished' : 'Waiting';

//                     const matchId = st.matchId ?? st.MatchId ?? null
//                     const target  = st.targetTapsPerBalloon ?? st.TargetTapsPerBalloon ?? null

//                     const zonesIn = st.zones ?? st.Zones;
//                     const zonesNorm = Array.isArray(zonesIn)
//                         ? zonesIn.map(z => ({
//                             zone: (z.zone ?? z.Zone ?? '').toString(),
//                             currentBalloonTaps: z.currentBalloonTaps ?? z.CurrentBalloonTaps ?? 0,
//                             completedBalloons:   z.completedBalloons   ?? z.CompletedBalloons   ?? 0,
//                             totalTaps:           z.totalTaps           ?? z.TotalTaps           ?? 0
//                         }))
//                         : null

//                     // Datos (sin tiempos)
//                     SetBalloonsAndRoute(b => ({
//                         ...b,
//                         matchId: matchId ?? b.matchId,
//                         status:  statusNorm,           // seguimos guardando status lógico
//                         startAt: null,
//                         endsAt:  null,
//                         target:  target ?? b.target,
//                         zones:   zonesNorm ?? b.zones
//                     }))

//                     // UI local (no retroceder)
//                     if (statusNorm === 'Running')  forceUIStatus('Running')
//                     if (statusNorm === 'Finished') forceUIStatus('Finished')
//                     // si viene Waiting y ya íbamos en Countdown/Running, NO bajamos

//                     break
//                 }

//                 case 'balloon.show-winners': {
//                     const d = message.data || {}

//                     SetBalloonsAndRoute(b => ({
//                         ...b,
//                         matchId: d.matchId ?? b.matchId,
//                         status: 'Finished',
//                         winners: {
//                             winnerType: d.winnerType || 'none',
//                             winners: d.winners || [],
//                             results: d.results || []
//                         }
//                     }))
//                     forceUIStatus('Finished') // UI a finalizado
//                     break
//                 }

//                 case 'balloon.reset': {
//                     // limpiar timeout si estaba activo
//                     if (countdownTimerRef.current) {
//                         clearTimeout(countdownTimerRef.current);
//                         countdownTimerRef.current = null;
//                     }

//                     SetBalloonsAndRoute({
//                         matchId: null,
//                         status: 'Waiting',
//                         startAt: null,
//                         endsAt: null,
//                         target: 0,
//                         zones: [],
//                         winners: null
//                     });
//                     setBalloonsUI({ uiStatus: 'Idle', countdownUntil: null });
//                     break;
//                 }

//                 case 'riddle': // Al ingresar al Tile del juego
//                     setLottery(null)
//                     setQuestion(null)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(11)
//                     break

//                 case 'newquestionriddler': // Al enviar una nueva adivinanza
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(11.1)
//                     break

//                 case 'resumequestionriddler': // Al reanudar la adivinanza; es decir, si me salí por error o actualicé y luego ingresé a la web durante el juego
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(11.1)
//                     break

//                 case 'riddledisplayitem': // Al mostrar el elemento oculto de la adivinanza
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(11.1)
//                     break

//                 case 'deselectedselfiefan': // Al deseleccionar la foto Selfie Fan
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(12)
//                     break

//                 case 'resetselfiefan': // Al reiniciar la dinámica de foto Selfie Fan
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(12)
//                     break

//                 case 'displayselfiefan': // Mostrar la foto Selfie Fan
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(12.1)
//                     break

//                 case 'selfiefan':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(13)
//                     break

//                 case 'displayselfiefania': // Mostrar la foto Selfie Fan con IA
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(14)
//                     break

//                 case 'deselectedselfiefania': // Al deseleccionar la foto Selfie Fan
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(12)
//                     break

//                 case 'quizzwithimageandoptions': // Al ingresar al Tile del juego
//                     setLottery(null)
//                     setQuestion(null)
//                     //setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(15)
//                     break

//                 case 'newquestionquizzwithimageandoptions': // Al enviar una nueva pregunta de trivia
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(15.1)
//                     break

//                 case 'resumequestionquizzwithimageandoptions': // Al reanudar la trivia; es decir, si me salí por error o actualicé y luego ingresé a la web durante el juego
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(15.1)
//                     break

//                 case 'frontpagenoisemeter':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(16)
//                     break

//                 case 'noisemeter.prepare':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(16.1)
//                     break

//                 case 'noisemeter.finished':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(16.1)
//                     break

//                 case 'qrmessages':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(17)
//                     break

//                 case 'qrpluckingrooster':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(18)
//                     break

//                 case 'rankingpluckingrooster':
//                     setLottery(null)
//                     setQuestion(message.data)
//                     setResults(null)
//                     //setColor(null)
//                     setActiveComponent(19)
//                     break

//                 // // ───────────── Tragamonedas ─────────────
//                 // case 'slotmachine.enter':
//                 //     setLottery(null)
//                 //     setQuestion(null)
//                 //     setResults(null)
//                 //     setActiveComponent(20) // ¡Esto monta la máquina en pantalla!
//                 //     break

//                 // ───────────── Tragamonedas ─────────────
//                 case 'slotmachine.enter':
//                 case 'slotmachine.prepare':
//                 case 'slotmachine.spin':
//                 case 'slotmachine.toggleqr':
//                 case 'slotmachine.togglethanks':
//                     setLottery(null);
//                     setQuestion(null);
//                     setResults(null);
                    
//                     // Guardamos el mensaje completo para pasárselo a la máquina
//                     setSlotPayload(message);
                    
//                     // Aseguramos que el componente 20 esté en pantalla
//                     setActiveComponent(20);
//                     break;

//                 default:
//                     // setLottery(null)
//                     // setQuestion(null)
//                     // setResults(null)
//                     // setActiveComponent(null)

//                     // Así nunca caerás a <Start /> por mensajes que no te interesan.
//                     console.log('Unknow:', message.type)
//                     break
//             }
//         }

//         connect()

//         document.body.classList.add('customBg')

//         return () => {
//             ClearSocketMessageHandler()
//             DisconnectWebSocket()
//             if (countdownTimerRef.current) clearTimeout(countdownTimerRef.current);
//         }
//     }, [])


//     return (
//         <>
//             {activeComponent === 1 && ( <Wait isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 2 && ( <Questions question={question} /> )}
//             {activeComponent === 3 && ( <Wait isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 3.1 && ( <Results payload={results} /> )}
//             {activeComponent === 4 && ( <Wait isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 4.1 && ( <Lottery payload={lottery} />)}
//             {activeComponent === 5 && (<Versus isActiveWomensMode={isActiveWomensMode} />)}
//             {activeComponent === 5.1 && (<GoalScreen state={goal} />)}
//             {activeComponent === 6 && ( <Colors /> )}
//             {activeComponent === 6.1 && ( <Colors /> )}
//             {activeComponent === 7 && ( <Start isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 8 && ( <Thanks isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 9 && ( <Welcome isActiveWomensMode={isActiveWomensMode} /> )}
//             {/* {activeComponent === 10 && ( <Wait isActiveWomensMode={isActiveWomensMode} /> )} */}
//             {activeComponent === 10 && ( <RojitoBrandFrontPage isActiveWomensMode={isActiveWomensMode} /> )}
//             {/* {activeComponent === 10.1 && ( <Balloons state={balloons} ui={balloonsUI} /> )} // Balloons general sin marcas */}
//             {activeComponent === 10.1 && ( <RojitoBrandBalloons state={balloons} ui={balloonsUI} isActiveWomensMode={isActiveWomensMode} /> )}
//             {/* {activeComponent === 11 && ( <Wait isActiveWomensMode={isActiveWomensMode} /> )} */}
//             {activeComponent === 11 && ( <RiddleFrontPage isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 11.1 && ( <Riddle riddle={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 12 && ( <Start isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 12.1 && ( <SelfieFan selfieFan={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 13 && ( <QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 14 && ( <SelfieFanIA selfieFan={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 15 && (<FrontPage data={question} />)} {/* Cambiar por la presentación del Hazle la lucha */}
//             {activeComponent === 15.1 && ( <QuizzWithImageAndOptions quizz={question} /> )}
//             {activeComponent === 16 && ( <FrontPageNoisemeter isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 16.1 && ( <Noisemeter data={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 17 && ( <QRMessages data={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 18 && ( <QRPluckingRooster data={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 19 && ( <RankingPluckingRooster data={question} isActiveWomensMode={isActiveWomensMode} /> )}
//             {activeComponent === 20 && ( <SlotMachine screenId={1} isStandalone={false} payload={slotPayload} isActiveWomensMode={isActiveWomensMode} /> )}
//             {!activeComponent && ( <Start isActiveWomensMode={isActiveWomensMode} /> )}
            
//             {toastMessage && (
//                 <div className="toast-container position-fixed bottom-0 start-50 translate-middle-x mb-3">
//                     <div className="toast show bg-success text-white px-3 py-2 shadow rounded">
//                         {toastMessage}
//                     </div>
//                 </div>
//             )}
//         </>
//     )
// }

// export { Screen };